<template>
	<div class="container register-page">
		<div class="content">
			<div class="flex-item left"></div>
			<div class="flex-item right">
				<div class="center" style="max-width: 280px;">
					<div class="title">
						<img class="lg-logo" src="../assets/img/logo.png" />
						<h4>{{$t('app.name')}}</h4>
					</div>

					<div class="box">
						<div class="item" :style="'background:' +item.bgc" v-for="(item,index) in signInType"
							:key="item.id" @click="handleGoPage(item,index)">
							<div class="logo" v-if="index==0">
								<img src="../assets/img/u357.png" />
							</div>
							<div class="logo" v-if="index==1">
								<img src="../assets/img/u38.png" />
							</div>
							<div class="text">{{item.text}}</div>
						</div>
					</div>
					<div id="buttonDiv" sytle="width:100%"></div>
					<div class="tips" @click="EmailLogin()">
						or log In with Email
					</div>
					
					<div class="service">
						<div style="margin: auto;">By creating an account, you accept our</div>
						<div style="margin: auto;"><span @click="Service()">Terms of Service </span> and <span @click="Privacy()"> Privacy Policy.</span></div>
					</div>
					
				</div>
			</div>
		</div>
	</div>
</template>

<script async defer crossorigin="anonymous" src="https://connect.facebook.net/en_US/sdk.js"></script>
<script src="https://accounts.google.com/gsi/client" async></script>
<script>
	import getDecodedOAuthJwtGoogle from "../common/utils/googlejwt.js"
	import {
		mapMutations
	} from 'vuex';
	import {
		userlogin,
		login
	} from "@/common/api/user.js"
	import {
		updateAuthorUserInfo,
		getAuthorUserInfo,
	} from '../common/api/home'
	import {mapState} from "vuex"
	export default {
		name: 'Register',
		data() {
			return {
				signInType: [{
						id: 0,
						bgc: '#1877F2',
						logo: '../assets/img/u357.png',
						text: 'Sign in with Facebook'
					},
					{
						id: 1,
						bgc: '#E43F77',
						logo: '../assets/img/u38.png',
						text: 'Sign in with Google'
					},
				],
			}
		},

		created() {

		},
		methods: {
			handleGoPage(item, index) {
				switch (index) {
					case 0:
						this.FacebLogin()
						// this.$message({
						// 	message: 'This feature is currently not available',
						// });
						break;
					case 1:
						this.googleLogin()
						// this.$message({
						// 	message: 'This feature is currently not available',
						// });
						break;
				}
			},
			googleLogin() {
				this.googleinit()
			},

			googleinit() {
				let googleId = this.$store.state.googleId
				google.accounts.id.initialize({
					client_id: "849421071823-7649e3vjt4595svhi5f9891a0l8h3l2e.apps.googleusercontent.com",
					callback: (response) => this.handleCredentialResponse(response)
				});
				google.accounts.id.renderButton(
					document.getElementById("buttonDiv"), {
						theme: "outline",
						size: "large"
					}
				);
				google.accounts.id.prompt();
			},
			async handleCredentialResponse(response) {
				console.log('handleCredentialResponse',response);
				//用标准的 import jwt from 'jsonwebtoken' 不起作用
				//谷歌使用自己的编码npm库- google-auth-library
				// const responsePayload = this.decodeJwtResponse(response.credential);
				const responsePayload = await getDecodedOAuthJwtGoogle(response.credential)
				this.bindLogin(responsePayload.payload, 'google')
			},
			bindLogin(e, type) {
				// let udid = uni.getStorageSync('uniqueness');
				console.log('bindLogin',e);
				let udid = 'uniqueness';
				let data = {
					data: {
						username: e.email,
						nickName: e.name,
						openId: e.sub, // Google 帐号的全局唯一标识符
						unionId: e.sub,
						headPortraitPath: e.picture || '',
						password: '',
						isOperator: false,
						uniqueness: udid,
						userEmail: e.email
					}
				}
				// data.password = md5.hex_md5(data.password)
				// uni.showLoading({
				// 	title: "loading..."
				// })
				
				login(data).then(res => {
					if (res.code == 0) {
						this.login(res.data)
						// uni.showToast({
						// 	title: 'login_success',
						// 	mask: true,
						// 	icon: 'none',
						// })
						this.$message.success({
							message: 'login_success',
						});
						let that = this
						setTimeout(function() {
							// //#ifdef APP-PLUS
							// uni.navigateBack()
							// // #endif
			
							////#ifdef H5
							// window.history.back(1)
							that.$store.dispatch("login", res.data).then(() => {
								console.log('that.$store.state.userInfo',that.$store.state.userInfo);
								if(that.$store.state.userInfo.pseudonym == ''){
									that.$router.push({
										path: 'myinformation'
									})
								} else {
									that.$router.replace({
										path: '/user/information'
									})
								}
							}).catch((err) =>{
								
							})
							//// #endif
						}, 2000)
			
			
					} else {
						// uni.showToast({
						// 	title: res.msg,
						// 	mask: true,
						// 	icon: 'none',
						// })
					}
			
				})
			},
			FacebLogin() {
				this.facebookinit()
				console.log('fh5');
				let that = this
				FB.login(function(response) {
					console.log('FB.login', response);
					if (response.authResponse) {
						FB.api('/me?fields=id,name,email,picture,permissions', function(response) {
							console.log('FB.api', response);
							console.log('FB.api', response.email);
							let uemail = response.email == undefined ? response.name : response.email
							let data = {
								userName: response.name,
								sub: response.id,
								email: uemail,
								picture: response.picture.data.url
							}
							that.bindLogin(data, 'facebook')

						});
					} else {
						console.log('User cancelled login or did not fully authorize.');
					}
				}, {
					scope: 'email,public_profile',
					return_scopes: true
				});
			},

			facebookinit() {
				FB.init({
					appId: this.$store.state.facebookId,
					autoLogAppEvents: true,
					xfbml: true,
					version: 'v15.0'
				});
				let that = this
				FB.getLoginStatus(function(response) { // Called after the JS SDK has been initialized.
					that.statusChangeCallback(response); // Returns the login status.
				});
			},

			statusChangeCallback(response) {
				if (response.status === 'connected') {

				} else {}
			},

			checkLoginState() { // Called when a person is finished with the Login Button.
				let that = this
				FB.getLoginStatus(function(response) { // See the onlogin handler
					that.statusChangeCallback(response);
				});
			},
			Service(){
				window.location.href = 'https://gw-reader.com/fiction-h5/UserServicesAgreement.html'
			},
			Privacy(){
				window.location.href = 'https://gw-reader.com/fiction-h5/Privacy%20Policy%20-%20GW%20Reader.html'
			},
			EmailLogin() {
				this.$router.replace({
					path: 'login'
				})
			},
			...mapMutations(['login'])
		}
	}
</script>

<style lang="scss" scoped="scoped">
	/deep/ .el-select .el-input__inner {
		border: none !important;
	}

	.register-page {
		background: url(../assets/img/bg.png) no-repeat;
		background-size: cover;

		.content {
			width: 70%;
			height: 60%;
			min-height: 450px;
			max-height: 550px;
			display: flex;
			flex-direction: row;
			position: relative;

			.agreent-box {
				width: 100%;
				height: 100%;
				position: absolute;
				top: 0;
				left: 0;
				background-color: #FFFFFF;
				display: flex;
				flex-direction: column;
				justify-content: space-between;
				align-items: center;
				z-index: 10;
				box-shadow: 0px 0px 28px 4px #cccccc;

				.tab {
					width: 100%;
					position: absolute;
					top: -34px;
					display: flex;
					flex-direction: row;
					justify-content: flex-start;
					align-items: center;

					.tab-item {
						height: 34px;
						width: 120px;
						line-height: 34px;
						background-color: #C4C4C4;
						margin-left: 30px;
						border-top-left-radius: 4px;
						border-top-right-radius: 4px;
						text-align: center;
						cursor: pointer;
					}

					.tabing {
						background-color: #FF8900;
						color: #FFFFFF;
					}
				}

				.ag-content {
					flex: 1;
					width: 100%;
					overflow-y: auto;
				}

				.back {
					height: 38px;
					font-size: 16px;
					color: #409EFF;
					padding-bottom: 10px;
					text-align: center;
					line-height: 38px;

					span {
						padding: 0 10px;
						cursor: pointer;
					}
				}
			}

			.flex-item {
				height: 100%;
				flex: 0 0 50%;
			}

			.left {
				background-image: url(../assets/img/login_bg1.png);
				background-size: cover;
			}

			.right {
				background-color: #ffffff;
				display: flex;
				justify-content: center;
				align-items: center;

				.center {
					width: 76%;
					max-width: 380px;
					display: flex;
					flex-direction: column;
					color: #656565;

					.title {
						display: flex;
						justify-content: center;
						align-items: center;
						letter-spacing: 2px;
						margin-bottom: 60px;
						color: #000000;

						.lg-logo {
							width: 45px;
							height: 45px;
							margin-right: 8px;
						}

						h4 {
							font-size: 18px;
						}
					}

					.box {
						display: flex;
						flex-direction: column;

						.item {
							border-radius: 10px;
							cursor: pointer;
							opacity: 1;
							padding: 17px;
							box-sizing: border-box;
							display: flex;
							align-items: center;
							margin-bottom: 25px;

							.logo {
								img {
									width: 24px;
									height: 24px;
								}
							}

							.text {
								margin-left: 15px;
								font-size: 20px;
								font-weight: 500;
								color: #FFFFFF;
								line-height: 23px;
							}
						}
					}

					.tips {
						cursor: pointer;
						margin-top: 20%;
						padding: 0 12%;
						box-sizing: border-box;
						text-align: center;
						// font-size: 12px;
						font-family: SF Pro Text-Medium, SF Pro Text;
						font-weight: 500;
						// color: #747474;
						line-height: 18px;
						text-decoration: underline;
						color: blue;
						font-size: 20px;
						margin-top: 0px;


					}
					
					.service{
						// position: absolute;
						// bottom: 60rpx;
						padding-top: 50px;
						bottom: 0;
						display: flex;
						flex-wrap: wrap;
						font-size: 26rpx;
						color: #D1D1D1;
						cursor: pointer;
						
						span{
							text-decoration: underline;
							
						}
					}

					.get {
						display: flex;
						justify-content: space-between;
						align-items: center;

						.getCode {
							width: 120px;
							height: 30px;
							background-color: transparent;
							border: 1px solid #C4C4C4;
							border-radius: 3px;
							margin-left: 10px;
							color: #656565;
							cursor: pointer;
							line-height: 30px;
							position: relative;
							top: 3px;
						}

						.sendGet {
							border: 1px solid #409EFF;
							color: #409EFF;
						}

						.geting {
							color: #A2A2A2;
						}
					}

					.row {
						display: flex;
						justify-content: flex-start;
						align-items: center;
						border-bottom: 1px solid #C4C4C4;
						margin-top: 5px;

						.icon-color {
							margin-right: 5px;
							color: #656565;
						}

						.lg-input {
							flex: 1;
							border: 0;
							height: 30px;
							line-height: 30px;
							font-size: 14px;
							outline: none;
						}
					}

					.agreent {
						font-size: 13px;
						margin-bottom: 15px;
						display: flex;
						justify-content: center;
						margin-top: 5px;
						cursor: pointer;

						.ag-checkbox {
							margin-right: 5px;
						}

						span {
							color: #FF8900;
							text-decoration: underline;
							margin-left: 5px;
						}
					}

					.sub-btn {
						margin: 7px 0;

						.btn {
							width: 100%;
							height: 30px;
							background-color: #FF8900;
							color: #ffffff;
							text-align: center;
							line-height: 30px;
							border: 0px;
						}

						.btn:hover {
							cursor: pointer;
						}
					}

					.row-text {
						line-height: 26px;
						text-align: center;

						span {
							color: #FF8900;
							cursor: pointer;
						}
					}
				}
			}
		}
	}
</style>